module.exports = __webpack_public_path__ + "static/media/JX.6e88f91d.png";